import React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography, Chip, Box, CircularProgress, Stack, useTheme } from '@mui/material';

const getTempoColor = (valor) => {
  if (valor <= 30) return 'success'; // verde - excelente
  if (valor <= 60) return 'warning'; // amarelo - aceitavel
  return 'error'; // vermelho - critico
};

const getRankColor = (idx) => {
  if (idx === 0 || idx === 1 || idx === 2) return 'success.main'; // Top 3 em verde
  else if (idx >= 3 && idx <= 6) return 'warning.main'; // Posicoes 4-7 em amarelo
  else return 'error.main'; // Posicoes 8+ em vermelho
};

const TempoPrimeiroServicoTable = ({ data = [], loading = false }) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  const sorted = [...data].sort((a, b) => {
    const aVal = typeof a.tempo_medio_primeiro_servico_minutos === 'number' ? a.tempo_medio_primeiro_servico_minutos : 99999;
    const bVal = typeof b.tempo_medio_primeiro_servico_minutos === 'number' ? b.tempo_medio_primeiro_servico_minutos : 99999;
    return aVal - bVal;
  });

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 220 }}>
        <CircularProgress size={48} thickness={4} />
      </Box>
    );
  }

  return (
    <TableContainer component={Paper} sx={{ borderRadius: 3, boxShadow: 3, mt: 3 }}>
      <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ px: 2, pt: 2 }}>
        <Typography variant="h6" sx={{ fontWeight: 700 }}>
          Tempo ate Primeiro Servico
        </Typography>
      </Stack>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell sx={{ fontWeight: 700, textAlign: 'center' }}>#</TableCell>
            <TableCell sx={{ fontWeight: 700 }}>Contrato</TableCell>
            <TableCell sx={{ fontWeight: 700, textAlign: 'center' }}>Tempo Medio (min)</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {sorted.length === 0 ? (
            <TableRow>
              <TableCell colSpan={3} align="center">
                <Typography color="text.secondary">Nenhum dado encontrado.</Typography>
              </TableCell>
            </TableRow>
          ) : (
            sorted.map((row, idx) => {
              const rankColor = getRankColor(idx);
              return (
                <TableRow key={row.des_contrato || idx} hover>
                  <TableCell align="center" sx={{ fontWeight: 700, fontSize: 20, color: rankColor }}>
                    {idx + 1}
                  </TableCell>
                  <TableCell>{row.des_contrato}</TableCell>
                  <TableCell align="center">
                    <Chip
                      label={typeof row.tempo_medio_primeiro_servico_minutos === 'number' ? `${row.tempo_medio_primeiro_servico_minutos.toFixed(2)} min` : '--'}
                      color={getTempoColor(row.tempo_medio_primeiro_servico_minutos)}
                      size="small"
                      sx={{ fontWeight: 700, fontSize: 15, minWidth: 80 }}
                    />
                  </TableCell>
                </TableRow>
              );
            })
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TempoPrimeiroServicoTable;
